import Layout from '@/layout';
var distributionRouter = {
  path: '/distribution',
  component: Layout,
  redirect: '/distribution/index',
  name: 'Distribution',
  meta: {
    title: '分销',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/distribution/index');
    },
    name: 'distributionIndex',
    meta: {
      title: '分销员管理',
      icon: ''
    }
  }, {
    path: 'distributionconfig',
    component: function component() {
      return import('@/views/distribution/config/index');
    },
    name: 'distributionConfig',
    meta: {
      title: '分销配置',
      icon: ''
    }
  }, {
    path: 'distributionOrder',
    component: function component() {
      return import('@/views/distribution/distributionOrder/index');
    },
    name: 'distributionOrder',
    meta: {
      title: '分销订单',
      icon: ''
    }
  }, {
    path: 'extend',
    component: function component() {
      return import('@/views/distribution/extend/index');
    },
    name: 'extend',
    meta: {
      title: '推广员列表',
      icon: ''
    }
  }, {
    path: 'agentConfig',
    component: function component() {
      return import('@/views/distribution/agent/config/index');
    },
    name: 'agentConfig',
    meta: {
      title: '代理配置',
      icon: ''
    }
  }, {
    path: 'agentList',
    component: function component() {
      return import('@/views/distribution/agent/list/index');
    },
    name: 'agentList',
    meta: {
      title: '代理列表',
      icon: ''
    }
  }, {
    path: 'agentPerformance',
    component: function component() {
      return import('@/views/distribution/agent/performance/index');
    },
    name: 'agentPerformance',
    meta: {
      title: '代理业绩',
      icon: ''
    }
  }, {
    path: 'agentWithdraw',
    component: function component() {
      return import('@/views/distribution/agent/withdraw/index');
    },
    name: 'agentWithdraw',
    meta: {
      title: '代理提现',
      icon: ''
    }
  }]
};
export default distributionRouter;